import { Box } from '@mui/material';
import TypeText from '../../../form/form-fields/TypeText';
import { useTranslation } from 'react-i18next';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import TypeCustomMultiSelect from '../../../form/form-fields/TypeCustomMultiSelect';

export const MatchingPropFieldSelect = ({ property, onChange }) => {
  const { t } = useTranslation();

  const publicLabelField = {
    label: property.label,
    key: 'publicLabel',
  };
  const valueField = {
    label: t('value'),
    key: 'value',
    options: property.options || [],
    noUnselect: true,
  };

  function handleUpdate(key, value) {
    const newProp = { ...property, [key]: value };
    onChange(newProp);
  }

  return (
    <Box className="flex items-center gap-1">
      <Box className="w-full">
        <TypeText
          size="small"
          field={publicLabelField}
          dataCollection={property}
          updateValidationOnChange={handleUpdate}
        />
      </Box>
      <KeyboardArrowRightIcon />
      <Box className="w-full">
        <TypeCustomMultiSelect
          size="small"
          field={valueField}
          dataCollection={property}
          startDataCollection={property}
          updateValidationOnChange={handleUpdate}
        />
      </Box>
    </Box>
  );
};
